export interface DocumentFileLineData {
	description: string;
	fileName: string;
	fileUrl: string;
	lookupId: string;
}

export class DocumentFileLineData implements DocumentFileLineData {
	description = "";
	fileName = "";
	fileUrl = "";
	lookupId = "";

	constructor(data?: Partial<DocumentFileLineData>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}